import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import {
   albumVideoImagePosterUrl,
   albumVideoSrcWithPeekHint,
} from '../../utils/albumVideoThumbnail';

type PhotoLike = {
   url?: string;
   videoUrl?: string;
   thumbnailUrl?: string;
};

/**
 * Muted grid preview for album videos: uses real image poster when available,
 * otherwise first-frame hint via #t= (no invalid poster=video URL).
 */
export const AlbumVideoGridPreview: React.FC<{
   photo: PhotoLike;
   onClick?: () => void;
   sx?: SxProps<Theme>;
}> = ({ photo, onClick, sx }) => {
   const rawSrc = (photo.url || (photo as { videoUrl?: string }).videoUrl || '').trim();
   const src = albumVideoSrcWithPeekHint(rawSrc);
   const poster = albumVideoImagePosterUrl(photo);

   return (
      <Box
         component='video'
         src={src}
         {...(poster ? { poster } : {})}
         muted
         preload='metadata'
         playsInline
         onClick={onClick}
         sx={sx}
      />
   );
};

export default AlbumVideoGridPreview;
